<template>
  <transition name="fade">
    <div class="mfp-wrap" v-if="isOpen">
      <div class="mfp-bg mfp-decide-later mfp-ready"></div>
      <div
        class="mfp-container"
        ref="container"
        @click="checkClick"
        @keydown="checkKeyDown"
        tabindex="1"
      >
        <div class="mfp-content">
          <div class="mfp-figure">
            <button
              title="Close (Esc)"
              type="button"
              class="mfp-close"
              @click.prevent="$emit('modal-close')"
            >
              ×
            </button>
            <figure class="com-container">
              <div class="com-header">
                Trade only - com orders
              </div>
              <div class="com-text">
                COM orders are only available to the trade and are subject to approval. All COM orders are final sale.
              </div>
              <div class="com-text com-contact">
                <span class="com-bold">QUESTIONS?</span> Email us at <a class="com-link" href="mailto:info@benchmademodern.com">info@benchmademodern.com</a>.
              </div>
              <span class="com-separator"></span>
              <div class="com-subheading">
                  How it works:
                </div>
              <div class="com-steps">
                <div class="com-text com-step">
                  <span class="com-numbered-box">1</span> You'll email us the link to the fabric you'd like to use.
                </div>
                <div class="com-text com-step">
                  <span class="com-numbered-box">2</span> We'll approve your fabric choice & confirm yardage
                </div>
                <div class="com-text com-step">
                  <span class="com-numbered-box">3</span> Once approved, you'll ship your materials to us
                </div>
                <div class="com-text com-step">
                  <span class="com-numbered-box">4</span> We'll build your custom design after fabric is received
                </div>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "COMModal",
  props: {
    isOpen: Boolean,
  },
  updated() {
    if (this.isOpen) {
      this.$refs.container.focus();
    }
  },
  methods: {
    checkClick(e) {
      if (e.target.classList.contains("mfp-container")) {
        this.$emit("modal-close");
      }
    },
    checkKeyDown(e) {
      if (e.keyCode == 27) {
        this.$emit("modal-close");
      }
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  background: rgba(11, 11, 11, 0.8);
  outline: 0 !important;
  -webkit-backface-visibility: hidden;
}
.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.mfp-content {
  max-width: 100%;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  z-index: 1045;
}
.mfp-close {
  width: 90%;
  height: 44px;
  line-height: 44px;
  text-decoration: none;
  text-align: center;
  padding: 0 0 18px 10px;
  font-style: normal;
  font-size: 2.5em;
  font-weight: 300;
  opacity: 1;
  font-family: Arial, Baskerville, monospace;
  overflow: visible;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: 0;
  z-index: 1046;
  -webkit-box-shadow: none;
  box-shadow: none;
  margin: 0;
  color: #fff;
  text-align: right;
  padding-right: 6px;
}
.com-container {
  width: 80%;
  max-width: 800px;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: white;
  line-height: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 30px 25px;
  margin: 0 auto;
}
.com-header {
  font-size: 25px;
  font-weight: 500;
  line-height: 32px;
  color: #292929;
  text-transform: uppercase;
}
.com-text {
  color: #292929;
  padding: 5px 0;
  height: 100%;
  line-height: 22px;
  font-family: Cardo, serif;
  font-size: 18px;
}
.com-contact {
  padding: 15px 0;
}
.com-bold {
  font-weight: 500;
  font-family: Sweet Sans Pro Med, Arial, sans-serif;
  text-transform: uppercase;
}
.com-link {
  color: #292929;
}
.com-separator {
  height: 1px;
  width: 120px;
  margin: 10px 0;
  background-color: black;
}
.com-subheading {
  font-size: 22px;
  line-height: 24px;
  font-weight: 500;
  color: #292929;
  text-transform: uppercase;
  padding: 15px 0;
}
.com-steps {
  display: flex;
  flex-direction: column;
}
.com-step {
  display: flex;
  gap: 5px;
  flex-direction: row;
  align-items: center;
}
.com-numbered-box {
  height: 30px;
  width: 30px;
  min-width: 30px;
  min-height: 30px;
  font-family: Sweet Sans Pro Med,Arial,sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 2px;
  background-color: #6d755f;
  margin: 10px;
}
figure {
  margin: 0;
}
.mfp-container::before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

@media (max-width: 768px) {
  .com-header {
    font-size: 20px;
  }
  .com-text {
    font-size: 14px;
    line-height: 18px;
  }
  .com-subheading {
    font-size: 16px;
  }
  .com-numbered-box {
    margin: 0 10px 0 0;
  }
  .com-container {
    width: 95%;
    padding: 20px 15px;
  }
  .mfp-close {
    width: 99%;
  }
}
</style>
